import { mapState, mapGetters, mapActions } from 'vuex'


// --------------------------COMPUTED (STATE AND GETTERS)-------------------------------

// Auth Computed
export const authComputed = {
  ...mapState('auth', {
    currentUser: state => state.currentUser,
  }),
  hasUserAuth() {
    return this.currentUser !== null && this.currentUser.id !== null;
  },
  ...mapGetters('auth', ['loggedIn']),
}


// Layout Computed
export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}



// Invoice Computed
export const invoiceComputed = {
  ...mapState('invoices', {
    invoices: (state) => state.invoices,
  }),
  ...mapGetters('invoices', ['allInvoices']),
}


// Supplier Computed
export const supplierComputed = {
  ...mapState('suppliers', {
    all_suppliers: (state) => state.all_suppliers,
  }),
  ...mapGetters('suppliers', ['getAllSuppliers']),
}


// Bank Computed
export const bankComputed = {
  ...mapState('banks', {
    all_banks: (state) => state.all_banks
  }),
  ...mapGetters('banks', ['getAllBanks']),
}


// Currency Computed
export const currencyComputed = {
  ...mapState('currencies', {
    all_currencies: (state) => state.all_currencies
  }),
  ...mapGetters('currencies', ['getAllCurrencies']),
}


// Accounting Account Computed
export const accountingAccountsComputed = {
  ...mapState('accounting_accounts', {
    all_accounting_accounts: (state) => state.all_accounting_accounts
  }),
  ...mapGetters('accounting_accounts', ['getAllAccountingAccounts']),
}




// --------------------------ACTIONS-------------------------------

// export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])
// export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])
export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])
export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])



// Auth actions
export const authMethods = mapActions('auth', ['logIn', 'logOut'])

//Bank actions
export const bankMethods = mapActions('banks', ['all'])

//Currencies actions
export const currenciesMethods = mapActions('currencies', ['all'])

//Supplier actions
export const supplierMethods = mapActions('suppliers', ['fetchSuppliers','store'])
export const supplierCategoryMethods = mapActions('supplierCategory', ['all'])


// Invoice Actions
export const invoiceMethods = mapActions('invoices', ['fetchInvoices', 'saveInvoice', 'updateInvoice', 'deleteInvoice', 'deleteInvoiceExpense', 'readInvoice'])


// Currency Actions
export const currencyMethods = mapActions('currencies', ['fetchAllCurrencies'])


// Accounting Account Actions
export const accountingAccountMethods = mapActions('accounting_accounts', ['fetchAllAccountingAccounts'])







